import script from "./ControlTowerView.vue?vue&type=script&setup=true&lang=js"
export * from "./ControlTowerView.vue?vue&type=script&setup=true&lang=js"

import "./ControlTowerView.vue?vue&type=style&index=0&id=3b7b42b8&lang=css"

const __exports__ = script;

export default __exports__